let isUserTypeFreeSnapshot = true;
export function getLsqIsUserTypeFreeSnapshot() {
    return isUserTypeFreeSnapshot;
}
export function setLsqIsUserTypeFree(isFree) {
    isUserTypeFreeSnapshot = isFree;
}
